// Core Imports
import * as React from 'react';

// Style, Media and  Misc imports
import './EmptyTracking.scss';
import emptyImage from 'src/assets/emptyInvoicesImage';
import Loader from 'src/components/common/Loader';

const EmptyTracking = (props: any) => {
  const { t } = props;
  switch (props.type) {
    case 'loading':
      return (
        <div className="rp-empty-tracking">
          <Loader />
        </div>
      );
    default:
    case 'noResults':
      return (
        <div className="rp-empty-tracking">
          <img src={emptyImage} alt="" />
          <h1>{t('tracking.empty_tracking')}</h1>
          <p>{t('invoices.appreciateBusiness')}</p>
        </div>
      );
    case 'noSearch':
      return (
        <div className="rp-empty-tracking">
          <img src={emptyImage} alt="" />
          <h1>{t('common.noResultsFound')}</h1>
          <p>{t('invoices.noInvoicesTryAgain')}</p>
        </div>
      );
  }
};

export default EmptyTracking;
